import type { ReactNode } from 'react'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'

export interface BlockedActionProps {
  /** Why the wrapped control is disabled; null renders the control as it is. */
  reason: string | null
  children: ReactNode
}

/**
 * A disabled control fires no pointer events, so it cannot carry a tooltip
 * itself: this focusable wrapper says why it is blocked, only while it is.
 * It brings its own provider, so it also works outside the app shell.
 */
export function BlockedAction({ reason, children }: BlockedActionProps) {
  if (!reason) return <>{children}</>
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          {/* biome-ignore lint/a11y/noNoninteractiveTabindex: the keyboard must reach the reason a disabled control hides */}
          <span className="inline-flex rounded-md" tabIndex={0} data-blocked-reason="">
            {children}
          </span>
        </TooltipTrigger>
        <TooltipContent className="max-w-xs text-xs leading-snug">{reason}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
